import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { getOrder } from '../../../order'
import Address from '../../../../addressbook/components/Address'
import AddressbookInfo from '../../../../addressbook/components/AddressbookInfo'
import Alert from '../../../../../ui/Alert'
import Bar from '../../../../../ui/Bar'
import Button from '../../../../../ui/Button'
import classNames from 'classnames'
import ImmutablePropTypes from 'react-immutable-proptypes'
import styles from '../css/Shipping.scss'
import { List } from 'immutable'

export class ListItem extends Component {
    static propTypes = {
        location: ImmutablePropTypes.map.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        onSelect: PropTypes.func.isRequired,
        tenant: ImmutablePropTypes.map.isRequired,
        products: PropTypes.array.isRequired,
    }

    renderSelectButton() {
        const { location, onSelect, tenant, order, products } = this.props;
        const isSelected = location.get('id') === order.get('location');

        const banned = location.get('bannedTenants').some(entry => {
            return entry.get('codePart') === tenant.get('code_part');
        });

        const declined = location.get('declined');

        if (banned) {
            return (
                <Alert type='info'>
                    <FormattedMessage id='frontend.form_selector_shipping.hint.banned' />
                </Alert>
            );
        }

        const service = order.get('service');
        let allPositions = List([]);

        if(service === 3) {
            allPositions = order.get('positions').get(1);
            allPositions.concat(order.get('positions').get(2));
        } else {
            allPositions = order.get('positions').get(service);
        }

        const blacklistedLocationProducts = location.get('blacklisted');

        const blacklistedProducts = allPositions && blacklistedLocationProducts.filter(product => {
            return allPositions.has(product);
        }).map(id => {
            return products.find(entry => id === entry.get('id'));
        }).toArray();

        if (blacklistedProducts && blacklistedProducts.length) {
            return (
                <Alert type='info'>
                    <FormattedMessage id='frontend.form_selector_shipping.hint.location.blacklist_addendum' />
                    {
                        blacklistedProducts.map((product, key) =>
                            <div key={key} style={{marginBottom: 0}}>
                                <strong>
                                    <FormattedMessage id={product.get('alias')} />
                                </strong>
                            </div>
                        )
                    }
                </Alert>
            );
        }

        if (declined) {
            return (
                <Alert type='warning'>
                    <FormattedMessage id='frontend.form_selector_shipping.hint.location.declined_addendum' />
                </Alert>
            );
        }

        return (
            <Button
                emphasis='secondary'
                onClick={e => onSelect(e, location)}
            >
                {isSelected ? (
                    <FormattedMessage
                        id='frontend.form_selector_shipping.headline.selected_address'
                    />
                ) : (
                    <FormattedMessage
                        id='frontend.form_selector_shipping.headline.select_address'
                    />
                )}
            </Button>
        );
    }

    render() {
        const { location, order } = this.props;
        const isSelected = location.get('id') === order.get('location');

        return (
            <div
                className={classNames(styles.address, { [styles.isSelected]: isSelected })}
            >
                <Address location={location} />
                <Bar>
                    <Bar.Section float='left'>
                        <AddressbookInfo location={location} />
                    </Bar.Section>
                    <Bar.Section float='right'>
                        {this.renderSelectButton()}
                    </Bar.Section>
                </Bar>
            </div>
        );
    }
}

export default connect(state => ({
    order: getOrder(state),
    tenant: state.tenant,
    products: Array.from(state.products.values()),
}))(ListItem);
